import { useParams, Navigate } from "react-router-dom";

/**
 * WorkbookDetailPage — Phase 12E (cycle-5c+25-fix8) redirect-only.
 *
 * The standalone `/workbook/:id` dedicated page was retired in favour of the
 * master-detail layout on `/?item=workbook:<id>`. Any existing bookmarks /
 * back-navigation hits here and is bounced to the equivalent unified URL.
 */
export default function WorkbookDetailPage() {
  const { id } = useParams();
  return <Navigate to={`/?item=workbook:${encodeURIComponent(id || "")}`} replace />;
}
